import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";
import { getProducts } from "@/lib/api";
import { waEncomenda } from "@/lib/whatsapp";
import { useSite } from "@/context/SiteContext";

const Importados = () => {
  const site = useSite();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Bonés Importados | DM IMPORTS";
    getProducts({ categoria: "Bonés Importados" })
      .then(setProducts)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section data-testid="importados-hero" className="relative flex min-h-[70svh] items-end overflow-hidden">
        <motion.img
          src={site.images.encomendasBg}
          alt="Bonés importados DM Imports"
          initial={{ scale: 1.12, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-obsidian/30" />
        <div className="relative mx-auto w-full max-w-7xl px-5 pb-20 pt-40 sm:px-8">
          <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-[11px] font-semibold uppercase tracking-[0.35em] text-silver">
            Linha importada
          </motion.p>
          <h1 data-testid="importados-title" className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-5xl lg:text-6xl">
            <span className="block overflow-hidden pb-1">
              <motion.span className="block" initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}>
                Bonés
              </motion.span>
            </span>
            <span className="block overflow-hidden pb-1">
              <motion.span className="block" initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.22, ease: [0.22, 1, 0.36, 1] }}>
                <span className="text-stroke">importados.</span>
              </motion.span>
            </span>
          </h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="mt-5 max-w-md text-sm text-zinc-400 sm:text-base">
            Modelos importados selecionados: Polo Ralph Lauren, Cabela's, Bass Pro Shops, Nike e mais. Valor e disponibilidade direto no WhatsApp.
          </motion.p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <p data-testid="importados-results-count" className="mb-8 text-xs uppercase tracking-[0.25em] text-zinc-500">
          {loading ? "Carregando modelos..." : `${products.length} ${products.length === 1 ? "modelo importado" : "modelos importados"}`}
        </p>
        <div data-testid="importados-grid" className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-3 xl:grid-cols-4">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>

        <Reveal data-testid="importados-order-cta" className="mt-16 rounded-2xl border border-white/10 bg-coal p-10 text-center sm:p-14">
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-silver">Encomendas</p>
          <h2 className="mt-3 font-display text-2xl font-extrabold uppercase tracking-tight text-offwhite sm:text-3xl">
            Procurando um importado específico?
          </h2>
          <p className="mx-auto mt-4 max-w-md text-sm text-zinc-400 sm:text-base">
            Trabalhamos com encomendas de modelos importados. Fale com a equipe e consulte disponibilidade.
          </p>
          <a href={waEncomenda()} target="_blank" rel="noopener noreferrer" data-testid="importados-order-whatsapp-button" className="mt-8 inline-flex items-center gap-3 rounded-full bg-offwhite px-9 py-4 text-xs font-bold uppercase tracking-[0.2em] text-obsidian transition-transform duration-300 hover:scale-[1.04]">
            <MessageCircle className="h-4 w-4" /> Fazer encomenda
          </a>
        </Reveal>
      </section>
    </>
  );
};

export default Importados;
